module.exports = __webpack_public_path__ + "img/31.8af8ec22.png";